export function getChangeApiTypeReducer(state, action) {
	return {
		...state,
		apiType: action.apiType,
	};
}
